import { DISPLAY_CURRENCIES } from "../lib/currency";

const LABELS = { TRY: "₺ TL", USD: "$ USD", AED: "د.إ AED", EUR: "€ EUR" };

export default function CurrencyBar({ value, onChange, rates }) {
  return (
    <div className="currency-bar" data-testid="display-currency-bar">
      <span className="currency-bar-label">Görüntüleme</span>
      {DISPLAY_CURRENCIES.map(code => {
        const disabled = code !== "TRY" && !rates?.[code];
        return (
          <button
            key={code}
            type="button"
            disabled={disabled}
            className={value === code ? "on" : ""}
            data-testid={`display-currency-${code}`}
            title={disabled ? "Bu para birimi için kur alınamadı" : `Tüm tutarları ${code} olarak göster`}
            onClick={() => onChange(code)}
          >
            {LABELS[code]}
          </button>
        );
      })}
    </div>
  );
}
